
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Friends',
    heroTitle: 'Invite friends',
    heroSubtitle: 'get coins and XP',
    empty: "You don't have any invited friends yet",
    invite: 'Invite friends',
    shareMessage:
      "🎁 I'm giving you a CS2 skin!\n\n⚡ Claim your drop in 1 minute right now on Telegram\n\n👇 Launch the app, complete tasks and get free skins every day!",
    statsInvited: 'Invited',
    statsEarned: 'Earned',
    statsRulesButton: 'Accrual Rules',
    bonusesTitle: 'Referral Bonuses',
    bonusesPerFriend: 'Friend activated:',
    bonusesPerFriendHint: "For a friend's deposit — right away, for a withdrawal — once they start playing",
    bonusesPer10thFriend: 'Every 10th activation:',
    bonusesFromDeposits: "From friend's deposits:",
    bonusesPerFriendL2: "Friend's friend activated:",
    bonusesFromDepositsL2: "From friend's friend deposits:",
    bonusesXpPerFriend: 'XP per activation:',
    activationExplanation: 'Activation = first deposit or item withdrawal',
    pendingActivation: 'Pending activation',
    activationRejected: 'No reward',
    rewardOnReview: 'Reward under review',
    shareButtonText: 'CLAIM FREE SKIN',
    errorsLoad: 'Failed to load referrals',
  },
  ru: {
    title: 'Друзья',
    heroTitle: 'Приглашай друзей',
    heroSubtitle: 'получай монеты и XP',
    empty: 'У тебя пока нет приглашённых друзей',
    invite: 'Пригласить друзей',
    shareMessage:
      '🎁 Я дарю тебе скин CS2!\n\n⚡ Забери свой дроп за 1 минуту прямо сейчас в Telegram\n\n👇 Запусти приложение, выполняй задания и получай бесплатные скины каждый день!',
    statsInvited: 'Приглашено',
    statsEarned: 'Заработано',
    statsRulesButton: 'Правила начисления',
    bonusesTitle: 'Реферальные бонусы',
    bonusesPerFriend: 'За активацию друга:',
    bonusesPerFriendHint: 'За депозит друга — сразу, за вывод — когда друг начнёт играть',
    bonusesPer10thFriend: 'За каждого 10-го:',
    bonusesFromDeposits: 'От депозитов друга:',
    bonusesPerFriendL2: 'За активацию друга друга:',
    bonusesFromDepositsL2: 'От депозитов друзей друзей:',
    bonusesXpPerFriend: 'XP за активацию:',
    activationExplanation: 'Активация = первый депозит или вывод предмета',
    pendingActivation: 'Ожидает активации',
    activationRejected: 'Без награды',
    rewardOnReview: 'Награда на проверке',
    shareButtonText: 'ЗАБРАТЬ БЕСПЛАТНЫЙ СКИН',
    errorsLoad: 'Не удалось загрузить рефералов',
  },
  uz: {
    title: 'Doʻstlar',
    heroTitle: 'Doʻstlarni taklif qil',
    heroSubtitle: "tangalar va XP oling",
    empty: 'Senda hali taklif qilingan doʻstlar yoʻq',
    invite: 'Taklif qilish',
    shareMessage:
      '🎁 Sizga CS2 skinini sovgʻa qilyapman!\n\n⚡ Telegramda hoziroq 1 daqiqada dropingizni oling\n\n👇 Ilovani ishga tushiring, topshiriqlarni bajaring va har kuni bepul skinlar oling!',
    statsInvited: 'Taklif qilingan',
    statsEarned: 'Ishlangan',
    statsRulesButton: "Hisoblash qoidalari",
    bonusesTitle: 'Referal bonuslari',
    bonusesPerFriend: 'Doʻst faollashganda:',
    bonusesPerFriendHint: 'Doʻst depoziti uchun — darhol, chiqarish uchun — doʻst oʻynay boshlagach',
    bonusesPer10thFriend: "Har 10-chi faollashtirish uchun:",
    bonusesFromDeposits: 'Doʻstning depozitlaridan:',
    bonusesPerFriendL2: 'Doʻstning doʻsti faollashganda:',
    bonusesFromDepositsL2: 'Doʻstlar doʻstlari depozitlaridan:',
    bonusesXpPerFriend: "Faollashtirish uchun XP:",
    activationExplanation: "Faollashtirish = birinchi depozit yoki buyumni chiqarish",
    pendingActivation: "Faollashtirishni kutmoqda",
    activationRejected: "Mukofot yoʻq",
    rewardOnReview: "Mukofot tekshiruvda",
    shareButtonText: 'BEPUL SKIN OLISH',
    errorsLoad: 'Referallarni yuklab boʻlmadi',
  },
  fa: {
    title: 'دوستان',
    heroTitle: 'دوستانت را دعوت کن',
    heroSubtitle: 'سکه و XP بگیر',
    empty: 'هنوز دوست دعوت‌شده‌ای نداری',
    invite: 'دعوت دوستان',
    shareMessage:
      '🎁 یک اسکین CS2 بهت می‌دهم!\n\n⚡ همین حالا در تلگرام یک‌دقیقه‌ای دراپت را بگیر\n\n👇 برنامه را باز کن، کارها را انجام بده و هر روز اسکین رایگان بگیر!',
    statsInvited: 'دعوت‌شده',
    statsEarned: 'کسب‌شده',
    statsRulesButton: 'قوانین واریز',
    bonusesTitle: 'بونوس‌های دعوت',
    bonusesPerFriend: 'دوست فعال شد:',
    bonusesPerFriendHint: 'برای شارژ دوستت فوراً، برای برداشت وقتی دوستت شروع به بازی کند',
    bonusesPer10thFriend: 'هر دهمین فعال‌سازی:',
    bonusesFromDeposits: 'از شارژهای دوستت:',
    bonusesPerFriendL2: 'دوستِ دوستت فعال شد:',
    bonusesFromDepositsL2: 'از شارژهای دوستِ دوستت:',
    bonusesXpPerFriend: 'XP هر فعال‌سازی:',
    activationExplanation: 'فعال‌سازی = اولین شارژ یا برداشت آیتم',
    pendingActivation: 'در انتظار فعال‌سازی',
    activationRejected: 'بدون جایزه',
    rewardOnReview: 'جایزه در حال بررسی',
    shareButtonText: 'اسکین رایگان را بگیر',
    errorsLoad: 'فهرست دعوت‌ها بارگذاری نشد',
  },
  pt: {
    title: 'Amigos',
    heroTitle: 'Convide amigos',
    heroSubtitle: 'ganhe moedas e XP',
    empty: 'Você ainda não tem amigos convidados',
    invite: 'Convidar amigos',
    shareMessage:
      '🎁 Estou te dando uma skin de CS2!\n\n⚡ Pegue seu drop em 1 minuto agora mesmo no Telegram\n\n👇 Abra o app, complete tarefas e ganhe skins grátis todo dia!',
    statsInvited: 'Convidados',
    statsEarned: 'Ganho',
    statsRulesButton: 'Regras de acúmulo',
    bonusesTitle: 'Bônus de indicação',
    bonusesPerFriend: 'Por amigo ativado:',
    bonusesPerFriendHint: 'Pelo depósito do amigo — na hora, pelo saque — quando ele começar a jogar',
    bonusesPer10thFriend: 'A cada 10º amigo:',
    bonusesFromDeposits: 'Dos depósitos do amigo:',
    bonusesPerFriendL2: 'Por amigo do amigo ativado:',
    bonusesFromDepositsL2: 'Dos depósitos dos amigos dos amigos:',
    bonusesXpPerFriend: 'XP por ativação:',
    activationExplanation: 'Ativação = primeiro depósito ou saque de item',
    pendingActivation: 'Aguardando ativação',
    activationRejected: 'Sem recompensa',
    rewardOnReview: 'Recompensa em análise',
    shareButtonText: 'PEGAR SKIN GRÁTIS',
    errorsLoad: 'Não deu para carregar as indicações',
  },
  tr: {
    title: 'Arkadaşlar',
    heroTitle: 'Arkadaşlarını davet et',
    heroSubtitle: 'coin ve XP kazan',
    empty: 'Henüz davet ettiğin arkadaşın yok',
    invite: 'Arkadaşlarını davet et',
    shareMessage:
      "🎁 Sana bir CS2 skini hediye ediyorum!\n\n⚡ Dropunu hemen şimdi Telegram'da 1 dakikada al\n\n👇 Uygulamayı aç, görevleri tamamla ve her gün bedava skin kazan!",
    statsInvited: 'Davet edilen',
    statsEarned: 'Kazanılan',
    statsRulesButton: 'Ödül kuralları',
    bonusesTitle: 'Davet bonusları',
    bonusesPerFriend: 'Arkadaş aktivasyonu:',
    bonusesPerFriendHint: 'Arkadaşının yatırımı için hemen, çekimi için oynamaya başlayınca verilir',
    bonusesPer10thFriend: 'Her 10. arkadaş için:',
    bonusesFromDeposits: 'Arkadaşının yatırımlarından:',
    bonusesPerFriendL2: 'Arkadaşının arkadaşının aktivasyonu:',
    bonusesFromDepositsL2: 'Arkadaşlarının arkadaşlarının yatırımlarından:',
    bonusesXpPerFriend: 'Aktivasyon başına XP:',
    activationExplanation: 'Aktivasyon = ilk yatırım ya da eşya çekimi',
    pendingActivation: 'Aktivasyon bekleniyor',
    activationRejected: 'Ödül yok',
    rewardOnReview: 'Ödül kontrolde',
    shareButtonText: 'BEDAVA SKİNİ AL',
    errorsLoad: 'Davetler yüklenemedi',
  },
  uk: {
    title: 'Друзі',
    heroTitle: 'Запрошуй друзів',
    heroSubtitle: 'отримуй монети та XP',
    empty: 'У тебе поки немає запрошених друзів',
    invite: 'Запросити друзів',
    shareMessage:
      '🎁 Дарую тобі скін CS2!\n\n⚡ Забери свій дроп за 1 хвилину просто зараз у Telegram\n\n👇 Запусти застосунок, виконуй завдання й отримуй безкоштовні скіни щодня!',
    statsInvited: 'Запрошено',
    statsEarned: 'Зароблено',
    statsRulesButton: 'Правила нарахування',
    bonusesTitle: 'Реферальні бонуси',
    bonusesPerFriend: 'За активацію друга:',
    bonusesPerFriendHint: 'За депозит друга — одразу, за виведення — коли друг почне грати',
    bonusesPer10thFriend: 'За кожного 10-го:',
    bonusesFromDeposits: 'Від депозитів друга:',
    bonusesPerFriendL2: 'За активацію друга друга:',
    bonusesFromDepositsL2: 'Від депозитів друзів друзів:',
    bonusesXpPerFriend: 'XP за активацію:',
    activationExplanation: 'Активація = перший депозит або виведення предмета',
    pendingActivation: 'Очікує активації',
    activationRejected: 'Без нагороди',
    rewardOnReview: 'Нагорода на перевірці',
    shareButtonText: 'ЗАБРАТИ БЕЗКОШТОВНИЙ СКІН',
    errorsLoad: 'Не вдалося завантажити рефералів',
  },
  de: {
    title: 'Freunde',
    heroTitle: 'Lade Freunde ein',
    heroSubtitle: 'und hol dir Münzen und XP',
    empty: 'Du hast noch keine eingeladenen Freunde',
    invite: 'Freunde einladen',
    shareMessage:
      '🎁 Ich schenke dir einen CS2-Skin!\n\n⚡ Hol dir deinen Drop in 1 Minute, direkt jetzt in Telegram\n\n👇 Starte die App, erledige Aufgaben und hol dir jeden Tag kostenlose Skins!',
    statsInvited: 'Eingeladen',
    statsEarned: 'Verdient',
    statsRulesButton: 'Regeln der Gutschrift',
    bonusesTitle: 'Empfehlungsboni',
    bonusesPerFriend: 'Freund aktiviert:',
    bonusesPerFriendHint: 'Für eine Einzahlung sofort, für eine Auszahlung, sobald dein Freund spielt',
    bonusesPer10thFriend: 'Für jeden 10.:',
    bonusesFromDeposits: 'Von Einzahlungen des Freundes:',
    bonusesPerFriendL2: 'Freund eines Freundes aktiviert:',
    bonusesFromDepositsL2: 'Von Einzahlungen von Freunden von Freunden:',
    bonusesXpPerFriend: 'XP pro Aktivierung:',
    activationExplanation: 'Aktivierung = erste Einzahlung oder Item-Auszahlung',
    pendingActivation: 'Wartet auf Aktivierung',
    activationRejected: 'Keine Belohnung',
    rewardOnReview: 'Belohnung wird geprüft',
    shareButtonText: 'GRATIS-SKIN HOLEN',
    errorsLoad: 'Empfehlungen konnten nicht geladen werden',
  },
  es: {
    title: 'Amigos',
    heroTitle: 'Invita a tus amigos',
    heroSubtitle: 'y consigue monedas y XP',
    empty: 'Aún no tienes amigos invitados',
    invite: 'Invitar amigos',
    shareMessage:
      '🎁 ¡Te regalo un skin de CS2!\n\n⚡ Reclama tu drop en 1 minuto, ahora mismo en Telegram\n\n👇 ¡Abre la aplicación, completa misiones y consigue skins gratis cada día!',
    statsInvited: 'Invitados',
    statsEarned: 'Ganado',
    statsRulesButton: 'Reglas de acreditación',
    bonusesTitle: 'Bonos por referidos',
    bonusesPerFriend: 'Por cada amigo activado:',
    bonusesPerFriendHint: 'Por el depósito del amigo, al instante; por la retirada, cuando empiece a jugar',
    bonusesPer10thFriend: 'Por cada décimo:',
    bonusesFromDeposits: 'De los depósitos del amigo:',
    bonusesPerFriendL2: 'Por cada amigo de un amigo activado:',
    bonusesFromDepositsL2: 'De los depósitos de amigos de amigos:',
    bonusesXpPerFriend: 'XP por activación:',
    activationExplanation: 'Activación = primer depósito o retirada de un objeto',
    pendingActivation: 'Pendiente de activación',
    activationRejected: 'Sin recompensa',
    rewardOnReview: 'Recompensa en revisión',
    shareButtonText: 'RECLAMAR SKIN GRATIS',
    errorsLoad: 'No se pudieron cargar los referidos',
  },
  pl: {
    title: 'Znajomi',
    heroTitle: 'Zapraszaj znajomych',
    heroSubtitle: 'i zgarniaj monety oraz XP',
    empty: 'Nie masz jeszcze zaproszonych znajomych',
    invite: 'Zaproś znajomych',
    shareMessage:
      '🎁 Daję ci skina do CS2!\n\n⚡ Odbierz swój drop w minutę, już teraz w Telegramie\n\n👇 Uruchom aplikację, wykonuj zadania i zgarniaj darmowe skiny każdego dnia!',
    statsInvited: 'Zaproszono',
    statsEarned: 'Zarobiono',
    statsRulesButton: 'Zasady naliczania',
    bonusesTitle: 'Bonusy za polecenia',
    bonusesPerFriend: 'Za aktywację znajomego:',
    bonusesPerFriendHint: 'Za wpłatę znajomego od razu, za wypłatę, gdy znajomy zacznie grać',
    bonusesPer10thFriend: 'Za każdego 10.:',
    bonusesFromDeposits: 'Z wpłat znajomego:',
    bonusesPerFriendL2: 'Za aktywację znajomego znajomego:',
    bonusesFromDepositsL2: 'Z wpłat znajomych znajomych:',
    bonusesXpPerFriend: 'XP za aktywację:',
    activationExplanation: 'Aktywacja = pierwsza wpłata lub wypłata przedmiotu',
    pendingActivation: 'Czeka na aktywację',
    activationRejected: 'Bez nagrody',
    rewardOnReview: 'Nagroda w weryfikacji',
    shareButtonText: 'ODBIERZ DARMOWY SKIN',
    errorsLoad: 'Nie udało się wczytać poleconych',
  },
});
